import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = [ 'tab', 'panel', 'dropdown', 'dropdownItem', 'dropdownSelected' ]

  connect() {
    this.activeClass = 'active'
    this.hiddenClass = 'hidden'
    this.index = this.data.get('index') || 0
    this.showTab()
  }

  changeTab(e) {
    e.preventDefault()

    this.index = e.currentTarget.dataset.index
    this.showTab()
  }

  showTab() {
    for (let index = 0; index < this.panelTargets.length; index++) {
      const panel = this.panelTargets[index]
      const tab = this.tabTargets[index]
      const dropdownItem = this.hasDropdownTarget ? this.dropdownItemTargets[index] : null

      if (index == this.index) {
        panel.classList.remove(this.hiddenClass)
        tab.classList.add(this.activeClass)

        if (dropdownItem) {
          dropdownItem.classList.add(this.activeClass)
          this.dropdownSelectedTarget.textContent = dropdownItem.textContent
          if (this.dropdownTarget.dropdown) { this.dropdownTarget.dropdown.closeImmediately() }
        }

      } else {
        panel.classList.add(this.hiddenClass)
        tab.classList.remove(this.activeClass)
        if (dropdownItem) { dropdownItem.classList.remove(this.activeClass) }
      }
    }
  }
}
